module.exports = __webpack_public_path__ + "img/Nachrichten_invertiert.3693b3f9.svg";